import {BottomNavigation, BottomNavigationAction, makeStyles, Theme} from '@material-ui/core';
import {useCurrentUser} from 'hooks/user';
import React from 'react';
import {FormattedMessage as FM} from 'react-intl';
import {useSelector} from 'react-redux';
import RouterLink from 'screens/common/RouterLink';
import {olxImportAllowedSelector} from 'store/global/selectors';
import {useUserSettings} from 'store/userSettings/reducer';
import {iosVersion, rieltor} from 'styles/theme';
import {NormalizedRoutes, RoleId} from '../../common/types';
import {Dashboard, MyWebsite,
  Offers,
  ProfileStats,
  WalletPlus,
} from '../../components/Icons';
import {useIsRieltorApp} from '../../hooks/useIsRieltorApp';
import cx from 'classnames';

const useStyles = makeStyles<Theme, {isRieltorApp: boolean}>(theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar,
    background: rieltor.purplePushed,
    justifyContent: 'space-around',

    '& .MuiBottomNavigationAction-root': {
      flex: 0,
      color: '#fff',
      opacity: 0.6,
      minWidth: 80,
      padding: '6px 0px 8px',
      pointerEvents: 'auto',
      '-webkit-touch-callout': 'none !important',
      '-webkit-user-select': 'none !important',
      '-webkit-tap-highlight-color': 'transparent !important' as any,
      '&.Mui-selected': {
        opacity: 1,
      },
      '&:focus': {
        outline: 'none !important',
        border: 'none !important',
      },
      '&:active': {
        // borderRadius: 0,
        // backgroundColor: 'transparent',
      }
    },

    '& .MuiBottomNavigationAction-label': {
      fontSize: '12px',
      lineHeight: '16px',
    }
  },
  glassMenu: {
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    bottom: props => (iosVersion >= 26 && !props.isRieltorApp ? 10 : 30),
    left: 24,
    right: 24,
    borderRadius: 30,
    background: 'rgb(112,27,206, 0.95)',
    // 'body.dialog-open &': {
    // },
  }
}));

const MobilePanelBottom = ({pathname}: { pathname: string }) => {
  const user = useCurrentUser();
  const isRieltorApp = useIsRieltorApp();
  const classes = useStyles({isRieltorApp});

  const glassMenu = iosVersion >= 26 || isRieltorApp;

  const normalizedPathname = pathname.endsWith('/')
    ? pathname.slice(0, pathname.length - 1)
    : pathname;

  const userSettings = useUserSettings();
  const isActivityEnabled = userSettings && userSettings.marketActivity && userSettings.marketActivity.enabled;

  if (user === null) {
    return null;
  }

  return (
    <BottomNavigation value={normalizedPathname} showLabels className={cx(classes.root, {[classes.glassMenu]: glassMenu})}>
      {
        user.roleId !== RoleId.Owner ? <BottomNavigationAction
          icon={<MyWebsite/>}
          value={NormalizedRoutes.Dashboard}
          label={<FM id="bottom_tabs.dashboard"/>}
          component={RouterLink}
          onClick={() => {
            document.body.scrollIntoView({
              behavior: 'smooth'
            });
          }}
          to={NormalizedRoutes.Dashboard}
        /> : null
      }

      {
        user.verificated && user.roleId === RoleId.Realtor && isActivityEnabled
          ? <BottomNavigationAction
            icon={<Dashboard/>}
            value={NormalizedRoutes.MarketActivity}
            label={<FM id="bottom_tabs.market"/>}
            component={RouterLink}
            to={NormalizedRoutes.MarketActivity}
          /> : null
      }

      <BottomNavigationAction
        icon={<Offers/>}
        value={NormalizedRoutes.OffersManagement}
        label={<FM id="bottom_tabs.offers"/>}
        component={RouterLink}
        onClick={() => {
          document.body.scrollIntoView({
            behavior: 'smooth'
          });
        }}
        to={NormalizedRoutes.OffersManagement}
      />

      <BottomNavigationAction
        icon={<ProfileStats/>}
        value={NormalizedRoutes.ProfileStats}
        label={<FM id="bottom_tabs.stats"/>}
        component={RouterLink}
        onClick={() => {
          document.body.scrollIntoView({
            behavior: 'smooth'
          });
        }}
        to={NormalizedRoutes.ProfileStats}
      />
    </BottomNavigation>
  );
};

export default MobilePanelBottom;
